import { Card, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import SecondaryCipNumberDataTable from '../../../components/datatables/secondary/SecondaryCipNumbersDataTable';
import Breadcrumbs from '../../../config/Breadcrumbs';
import InstitutionDTO from '../../../models/InstitutionDTO';
import UserSecurity from '../../../models/UserSecurity';
import HeaderPortal from '../../../portals/HeaderPortal';
import { StateStoreModel } from '../../../redux/state/StateStoreModel';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface AcademicYearSecondaryCipNumberConfigurationPageState {
  loading: boolean;
  academicYear: number;
}

interface AcademicYearSecondaryCipNumberConfigurationPageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class AcademicYearSecondaryCipNumberConfigurationPage extends React.Component<AcademicYearSecondaryCipNumberConfigurationPageProps & RouteComponentProps<RouteObject>, AcademicYearSecondaryCipNumberConfigurationPageState> {

  constructor(props: AcademicYearSecondaryCipNumberConfigurationPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      loading: false,
      academicYear: 0,
    };
  }

  componentDidMount() {
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));

    this.setState({ academicYear: id });
  }

  private onBack = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content >
        <HeaderPortal title='CIP Numbers' breadcrumbs={Breadcrumbs.academicYearSecondaryCipNumberConfigurationList(this.state.academicYear)}
          onBack={this.onBack} />
        < Space direction="vertical" size="large">
          <Card title="CIP Numbers">
            <Space direction='vertical' size="large">
              <SecondaryCipNumberDataTable
                academicYear={this.state.academicYear}
                isConfiguration={true} />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(AcademicYearSecondaryCipNumberConfigurationPage));
